import { getCookie, setCookie } from "cookies-next";
import {
  PROD_BASE_URL,
  PROD_EMAIL,
  PROD_PASSWORD,
  SAND_BASE_URL,
  SAND_EMAIL,
  SAND_PASSWORD,
} from "../constant/env";
import { EAnalysesType } from "../oz/constants/ozConstant";
import {
  apiRequest,
  apiRequest2,
  axiosInstance,
  sandboxInstance,
} from "./ozApi";
import OzAPIPath from "./ozApiPath";
import {
  TAnalysesFolderByIdResponse,
  TAnalysis,
  TLivenessResponse,
  TSingleResponseApi,
} from "./ozType";

export const authenticateOz = async () => {
  try {
    const response = await axiosInstance.post(
      PROD_BASE_URL + OzAPIPath.getApiPath("AUTHORIZE_AUTH"),
      {
        credentials: {
          email: PROD_EMAIL,
          password: PROD_PASSWORD,
        },
      }
    );

    if (response.data && response.data.access_token) {
      const access_token = await response?.data.access_token;
      const expire_token = await response.data.expire_token;

      setCookie("access_token", access_token);
      setCookie("expire_token", expire_token);
    }

    return response;
  } catch (error) {
    console.log("Error Authenticating:", error);
  }
};

export const authenticateOz2 = async () => {
  try {
    const response = await sandboxInstance.post(
      SAND_BASE_URL + OzAPIPath.getApiPath("AUTHORIZE_AUTH"),
      {
        credentials: {
          email: SAND_EMAIL,
          password: SAND_PASSWORD,
        },
      }
    );

    if (response.data && response.data.access_token) {
      const access_token = await response?.data.access_token;
      const expire_token = await response.data.expire_token;

      setCookie("access_token2", access_token);
      setCookie("expire_token2", expire_token);
    }

    return response;
  } catch (error) {
    console.log("Error Authenticating:", error);
  }
};

export const handleTokenRefresh1 = async () => {
  console.log("Getting the refresh token 1");
  const expire_token = getCookie("refresh_token");
  console.log({ expire_token });
  const response = await apiRequest({
    url: OzAPIPath.getApiPath("TOKEN_RENEWAL"),
    data: {
      expire_token,
    },
  });
  console.log({ response });
  return response;
};

export const handleTokenRefresh2 = async () => {
  console.log("Getting the refreh token 2");
  const expire_token = getCookie("refresh_token2");
  console.log({ expire_token });
  const response = await apiRequest2({
    url: OzAPIPath.getApiPath("TOKEN_RENEWAL"),
    data: {
      expire_token,
    },
  });
  console.log({ response });
  return response;
};

export const handleLivenessResult = async ({
  transactionId,
}: {
  transactionId: string;
}): Promise<TLivenessResponse> => {
  const response = await apiRequest<TLivenessResponse>({
    url: OzAPIPath.getDynamicPath(
      "ANALYSES_RESULT_BY_TRANSACTION_ID",
      transactionId
    ),
  });

  return response;
};

export const handleSingleRequest = async (formData: FormData) => {
  return await apiRequest2<TSingleResponseApi>({
    url: OzAPIPath.getApiPath("FOLDERS"),
    method: "POST",
    data: formData,
  });
};

// Upload Media to the folder by id
export const uploadMediaToFolderById = async <T>({
  folderId,
  formData,
}: {
  folderId: string;
  formData: FormData;
}) => {
  return await apiRequest<T>({
    url: OzAPIPath.getDynamicPath("UPLOAD_MEDIA_BY_FOLDER_ID", folderId),
    method: "POST",
    data: formData,
  });
};

export const analysesFolderById = async ({
  folderId,
  data,
}: {
  folderId: string;
  data: {
    analyses: { type: EAnalysesType }[];
  };
}) => {
  return await apiRequest<TAnalysesFolderByIdResponse>({
    url: OzAPIPath.getDynamicPath("ANALYSES_FOLDER_BY_FOLDER_ID", folderId),
    method: "POST",
    data,
  });
};

export const pollAnalysesById = async ({
  analysisId,
}: {
  analysisId: string;
}) => {
  return await apiRequest<TAnalysis>({
    url: OzAPIPath.getDynamicPath("POLL_ANALYSES_BY_ANALYSIS_ID", analysisId),
    method: "GET",
  });
};
